import React, { FC, useRef, useState } from 'react';
import Svg from 'svg-inline-react';
import classNames from 'classnames';
import { OutsideClick } from '@src/components/OutsideClick';
import FrChevronDown from '@src/svgs/fr-expand.svg';
import { useGetSpecialitiesQuery } from '@src/graphql/generated';
import { DEFAULT_SPECIALITY_KEY } from '../constants/filters';
import { SelectSpecialityProps } from './props';
import './styles.scss';

export const SelectSpeciality: FC<SelectSpecialityProps> = ({
  selectedSpecialityId,
  onSelect,
  className,
  labelClassName,
}) => {
  const scrollableRef = useRef<HTMLDivElement>(null);

  const [isShown, setIsShown] = useState<boolean>(false);

  const { data, loading: isLoading } = useGetSpecialitiesQuery();

  if (isLoading || !data) {
    return null;
  }

  const specialities = data?.specialities || [];

  const selectedSpeciality = specialities.find(speciality => speciality?.id === selectedSpecialityId);

  const onSpecialitySelect = (specialityId: string, specialityName: string): void => {
    onSelect(specialityId, specialityName);
  };

  return (
    <OutsideClick addOutsideClickListener={isShown} onOutsideClick={() => setIsShown(false)}>
      <div className={classNames('featured-candidates-select-speciality', className)}>
        <div className="featured-candidates-select-speciality__selected" onClick={() => setIsShown(!isShown)}>
          <div className={classNames('featured-candidates-select-speciality__selected-speciality', labelClassName)}>
            {selectedSpeciality?.name || 'Filter by speciality'}
          </div>

          <Svg
            className={classNames(
              'featured-candidates-select-speciality__button-icon',
              isShown && 'featured-candidates-select-speciality__button-icon--rotate',
            )}
            src={FrChevronDown}
          />
        </div>

        {isShown && (
          <div className="featured-candidates-select-speciality__dropdown" ref={scrollableRef}>
            <div
              className="featured-candidates-select-speciality__dropdown-item"
              onClick={() => {
                onSpecialitySelect(DEFAULT_SPECIALITY_KEY, DEFAULT_SPECIALITY_KEY);

                setIsShown(false);
              }}
            >
              All
            </div>

            {specialities.map(speciality => {
              return (
                <div
                  className="featured-candidates-select-speciality__dropdown-item"
                  key={speciality?.id}
                  onClick={() => {
                    setIsShown(false);

                    if (speciality) {
                      onSpecialitySelect(speciality?.id, speciality?.name);
                    }
                  }}
                >
                  {speciality?.name}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </OutsideClick>
  );
};
